<!-- 新闻列表 -->
<template>
  <div>
    <div class="component-header">
      <!-- 背景图 开始 -->
      <img src="../assets/images/listbg.png" class="bgbanner" />
      <!-- 背景图 结束 -->
    </div>
    <div
      class="page-index"
      :class="{
        maincontenttopmobile: isphone,
        maincontenttoppc: isphone == false
      }"
    >
      <div class="component-news-list">
        <div class="all-content">
          <div class="context">
            <div class="contextleft">
              <ul>
                <li
                  class="list "
                  :class="{ active: menutype == zxzxnum }"
                  @click="changemenu(zxzxnum)"
                >
                  <p align="center">烈士公祭·最新资讯</p>
                </li>
                <li
                  class="list"
                  :class="{ active: menutype == jsccnum }"
                  @click="changemenu(jsccnum)"
                >
                  <p align="center">祭奠英烈·精神传承</p>
                </li>
                <li
                  class="list"
                  :class="{ active: menutype == gthwnum }"
                  @click="changemenu(gthwnum)"
                >
                  <p align="center">英烈之名·共同捍卫</p>
                </li>
              </ul>
            </div>
            <div class="border"></div>
            <div>
              <div class="contextright" v-loading="loading">
                <ul>
                  <li v-for="(item, index) in nameList" :key="index">
                    <a
                      :href="
                        'http://yinglie.chinamartyrs.gov.cn/zhylw/zcfg/content.html?id=' +
                          item.basicId
                      "
                      target="_blank"
                    >
                      <span>{{ item.basicTitle }}</span>
                      <p>{{ parseTime(item.basicAdddate, "{y}-{m}-{d}") }}</p>
                    </a>
                  </li>
                </ul>

                <!-- 分页 开始 -->
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="total"
                  :page-size="size"
                  :current-page="current"
                  @current-change="changeCurrentPage"
                  :hide-on-single-page="true"
                  class="list-pagination"
                >
                </el-pagination>
                <!-- 分页 结束 -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDeedsdatas } from "@/api/index";
export default {
  name: "ComponentNewsList",
  data() {
    return {
      isphone: false,
      loading: true,
      total: 0, // 数据总量
      size: 9, // 每页显示的数据数量
      current: 1, // 当前页数
      nameList: [],
      // 测试环境
      // menutype: 138,
      // jsccnum: 139,
      // gthwnum: 141,
      // zxzxnum: 138,
      // gdgjhdnum: 142,
      // wlsbsnum: 143,
      // zcfgnum: 144,
      // jyzfnum: 145
      // 正式环境
      menutype: 191,
      jsccnum: 192,
      gthwnum: 196,
      zxzxnum: 191,
      gdgjhdnum: 193,
      wlsbsnum: 194,
      zcfgnum: 197,
      jyzfnum: 198
    };
  },
  mounted() {
    this.menutype = this.$route.query.type;
    if (this.isMobile()) {
      this.isphone = true;
    } else {
      this.isphone = false;
    }
    this.getList();
  },
  methods: {
    // 切换menu
    changemenu(menu) {
      this.menutype = menu;
      this.current = 1;
      this.getList();
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    /**
     * ##########################################################################################
     * @description 切换烈士列表页码
     * @param {Number} currentPage : 切换后的页码
     * ##########################################################################################
     */

    changeCurrentPage(currentPage) {
      this.current = currentPage;
      this.getList();
      console.log("最新页码：" + currentPage);
    },
    /**
     * ##########################################################################################
     * @description 获取烈士姓名列表
     * ##########################################################################################
     */

    getList() {
      // TODO: request login api
      this.loading = true;
      console.log(this.menutype);
      // 如果是 祭奠英烈·精神传承 和 英烈之名·共同捍卫就查下面的子栏目的数据
      if (this.menutype == this.jsccnum) {
        var jsccnumarr = [];

        getDeedsdatas(this.gdgjhdnum).then(res => {
          jsccnumarr = jsccnumarr.concat(res["rows"]);
          getDeedsdatas(this.wlsbsnum).then(res => {
            jsccnumarr = jsccnumarr.concat(res["rows"]);
            this.total = jsccnumarr.length;
            this.nameList = jsccnumarr.slice(
              (this.current - 1) * this.size,
              this.current * this.size
            );
            this.loading = false;
          });
        });
      }
      if (this.menutype == this.gthwnum) {
        var jsccnumarr = [];
        getDeedsdatas(this.zcfgnum).then(res => {
          jsccnumarr = jsccnumarr.concat(res["rows"]);
          getDeedsdatas(this.jyzfnum).then(res => {
            jsccnumarr = jsccnumarr.concat(res["rows"]);
            this.total = jsccnumarr.length;
            this.nameList = jsccnumarr.slice(
              (this.current - 1) * this.size,
              this.current * this.size
            );
            this.loading = false;
          });
        });
      }
      // 最新资讯
      if (this.menutype == this.zxzxnum) {
        getDeedsdatas(this.menutype, this.current, this.size).then(res => {
          if (res.code == "200") {
            this.nameList = res.rows;
            this.total = res.total;
            this.loading = false;
          } else {
            this.$message.error(res.msg);
            this.loading = false;
          }
          // this.total = res.length;
          // this.nameList = res["rows"].slice(
          //   (this.current - 1) * this.size,
          //   this.current * this.size
          // );
          // this.loading = false;
        });
      }
    }
  }
};
</script>

<!-- 组件独有样式 -->
<style scoped>
li {
  list-style: none;
}
.bgbanner {
  display: block;
  width: 100%;
  height: 1300px;
}
.container-wrapper {
  height: 1000px !important;
}
/* 分页 */
.list-pagination {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.maincontenttoppc {
  width: 100%;
  position: absolute;
  /* pc端 */
  top: 860px;
}
.maincontenttopmobile {
  width: 100%;
  position: absolute;
  /* 手机端 */
  top: 25%;
}
.component-news-list {
  margin: 0 auto;
}
.component-news-list {
  width: 1200px;
  min-width: 1200px;
  height: 800px;
  background-color: #ffffff;
  border-radius: 15px;
  margin-top: 18px;
}
.all-content {
  width: 1140px;
  height: 440px;
  position: relative;
  margin: 0 auto;
  top: 30px;
}

html,
body {
  padding: 0;
  margin: 0;
}
a {
  text-decoration: none;
  outline: none;
  color: #000;
}

.contextleft {
  width: 230px;
  margin-top: 42px;
  margin-left: 32px;
  float: left;
}
.contextleft:hover {
  cursor: pointer;
}
.contextleft > ul {
  padding: 0;
}
.contextleft ul li {
  height: 40px;
  line-height: 45px;
}
.list {
  list-style: none;
  width: 100%;
  height: 35px;
  background-color: #d3d3d3;
  line-height: 35px;
  font-size: 16px;
  color: #000;
  margin-top: 9px;
}
.active {
  color: #fff;
  background-color: #d0151b;
}
.border {
  width: 1px;
  height: 632px;
  background-color: #bfbfbf;
  float: left;
  margin-top: 58px;
  margin-left: 48px;
}
.contextright {
  width: 700px;
  height: 744px;
  margin-top: 58px;
  margin-left: 50px;
  float: left;
  position: relative;
}
.display {
  display: none;
}
.contextright li {
  height: 23px;
  margin-top: 18px;
}
/* .contextright li:nth-child(5n + 5) {
  border-bottom: 1px solid #ddd;
} */
.contextright li:hover {
  color: #d0151b;
}
.contextright a:hover {
  color: #d0151b;
}
.contextright p {
  display: inline;
  margin-left: 20px;
  color: #b5b5b5;
  font-size: 10px;
  float: right;
}
.contextright span {
  width: 500px;
  font-size: 16px;
  float: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.borderbuttom {
  width: 800px;
  height: 1px;
  margin-left: 20px;
  background-color: #ddd;
}
.title {
  width: 800px;
  margin: 0 auto;
  margin-top: 36px;
  text-align: center;
}

.detail {
  padding: 0 50px;
}
.detail p {
  font-size: 18px;
  text-indent: 36px;
  line-height: 40px;
}
.time {
  font-size: 24px;
  margin-left: 250px;
}
.time span {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/pages/newslist.vue